if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"bccFrontend","remotes":[{"alias":"workflowEditorV3","name":"workflowEditorV3","entry":"https://dev.blancco.cloud/workflow-editors/V3/mf-manifest.json","shareScope":"default","externalType":"script"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return 340 != chunkId},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {"workflowEditorV3":[{"alias":"workflowEditorV3","name":"workflowEditorV3","entry":"https://dev.blancco.cloud/workflow-editors/V3/mf-manifest.json","shareScope":"default","externalType":"script"}]}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}